export default __webpack_public_path__ + "static/media/close.3e94e617.svg";